import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHumansignal = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.81287 0.0460205C5.97884 0.0460205 5.30273 0.722132 5.30273 1.55615V9.14115C5.30273 9.14886 5.30279 9.15655 5.30291 9.16422V5.34868H10.6054V10.6513H14.3975C15.2316 10.6513 15.9077 9.97517 15.9077 9.14115V1.55615C15.9077 0.72213 15.2316 0.0460205 14.3975 0.0460205H6.81287Z",
		fill: "#FFA663"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.09485 15.9539C9.92887 15.9539 10.605 15.2777 10.605 14.4437V6.85872C10.605 6.85415 10.605 6.84958 10.6049 6.84501V10.6512H5.30245V5.3486H9.10027C9.09847 5.34859 9.09666 5.34859 9.09485 5.34859H1.51017C0.676146 5.34859 3.62396e-05 6.0247 3.62396e-05 6.85873V14.4437C3.62396e-05 15.2777 0.676145 15.9539 1.51017 15.9539H9.09485Z",
		fill: "#FF7557"
	})]
});
const ForwardRef = forwardRef(SvgHumansignal);
export { ForwardRef as ReactComponent };
